import { checkoutSharedStyles } from "@tps/App/SharedStyles/CheckoutSharedStyles";
import { orderInformationStyles } from "@tps/Overrides/Widgets/OrderConfirmation/OrderConfirmationOrderInformation";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

orderInformationStyles.billingShippingWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        row-gap: 24px;
        flex-wrap: wrap;
        width: 100%;
    `,
};
orderInformationStyles.billingInformationWrapper = {
    css: css`
        width: 430px;
        ${xScreen("lte", "md")} {
            width: 100%;
            justify-content: flex-start;
        }
    `,
};
orderInformationStyles.shippingInformationGridItem = {
    css: css`
        width: 430px;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-end;
        ${xScreen("lte", "md")} {
            width: 100%;
            justify-content: flex-start;
        }
    `,
};
orderInformationStyles.orderConfirmationBillingInformation = {
    billingInformationGridContainer: {
        gap: 0,
    },
    billingAddressTitle: {
        ...checkoutSharedStyles.subSectionTitle,
    },
    billingInformationTitleGridItem: {
        css: css`
            display: none;
            @media print {
                display: none !important;
            }
        `,
    },
    billingInformationTitle: {
        css: css`
            display: none;
            @media print {
                display: none;
            }
        `,
    },
};
orderInformationStyles.notesTitle = {
    as: "p",
    weight: "bold",
    size: 14,
    lineHeight: "22px",
    css: css`
        margin-bottom: 4px;
    `,
};
orderInformationStyles.notesDescription = {
    forwardAs: "p",
    weight: "normal",
    size: 14,
    lineHeight: "22px",
};
orderInformationStyles.notesGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};
orderInformationStyles.requiresMtr = {
    forwardAs: "p",
    size: 12,
    lineHeight: "17px",
    css: css`
        margin: 4px 0 0;
        &.requireMargin {
            margin-bottom: 16px;
        }
    `,
};
orderInformationStyles.dateRequestedTitle = {
    forwardAs: "p",
    weight: "bold",
    size: 14,
    lineHeight: "22px",
    css: css`
        margin-bottom: 4px;
    `,
};
orderInformationStyles.dateRequestedText = {
    forwardAs: "p",
    weight: "normal",
    size: 14,
    lineHeight: "22px",
};
orderInformationStyles.detailsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 20px;
    `,
};
